export const WARN_LEVEL_1_VALUE = 100;
export const WARN_LEVEL_2_VALUE = 1000;
export const STATUS_OPEN = 'Open';
export const STATUS_WARN_LEVEL_1 = 'WarnLevel1';
export const STATUS_WARN_LEVEL_2 = 'WarnLevel2';
export const STATUS_WARN_BUNDLE_RELEASE_STATE = 'WarnBundleReleaseState';
export const STATUS_CONFIRMED = 'Confirmed';
export const MONITORED_RELEASE_STATES = 'LIVE, TEST';
